import * as React from "react";
import cable from "~/lib/cable";

import Spinner from "~/components/shared/Spinner";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import {
  jobArtifactsCountQueryKey,
  jobArtifactsCountQueryOptions,
} from "~/components/build/Show/lib/queries/jobArtifactsCount";
import { Build } from "~/components/build/Show/lib/types";

type JobProps = {
  job: {
    id: string;
    basePath: string;
  };
};

type Props = JobProps & {
  build: Build;
};

export default function ArtifactsCount(props: Props) {
  const queryClient = useQueryClient();

  const { data: count } = useQuery(
    jobArtifactsCountQueryOptions(props.build.id, props.job.id, props.job.basePath),
  );

  React.useEffect(() => {
    const sub = cable.subscriptions.create(
      { channel: "Pipelines::JobChannel", uuid: props.job.id },
      {
        component: ArtifactsCount,
        received({ event }) {
          if (event === "artifacts:changed") {
            queryClient.invalidateQueries({
              queryKey: jobArtifactsCountQueryKey(props.build.id, props.job.id),
              exact: true,
            });
          }
        },
      },
    );

    return () => sub.unsubscribe();
  }, []);

  if (count === undefined) {
    return <Spinner className="ml-1" />;
  }

  return <span className="badge badge--outline tabular-numerals ml-1">{count}</span>;
}
